import LocomotiveScroll from 'locomotive-scroll';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

//jQuery
import $ from 'jquery';

//=== Cursor
import Cursor from './cursor';
import Magnetic from './magnetic';

gsap.registerPlugin(ScrollTrigger);

//=== init Cursor
// Init cursor
const cursor = new Cursor({
  container: 'body', // container to attach
  speed: 0.7, // default speed
  ease: 'expo.out', // default ease (gsap)
  visibleTimeout: 300, // disappear timeout
});

const magnetic = new Magnetic({
  y: 0.2,
  x: 0.2,
  s: 0.2,
  rs: 0.7,
});

// Automatic handle magnetic elements through attribute
$('[data-magnetic]').each(function () {
  new Magnetic(this);
});

// Hamburger Nav Open/Close
const hamburger = document.querySelector('.nav-hamburger');
const hamburgerInner = document.querySelector('.nav-hamburger__inner');
const hamburgerBefore = document.querySelector('.nav-hamburger__inner-before');
const sideNav = document.querySelector('.sideNav');
const skrim = document.querySelector('.sideNav_skrim');
const sideWrap = document.querySelector('.sideNav_navContent');
const sideNavContent = document.querySelector('.sideNav_navContent-wrapper');
const sideNavContentLine = document.querySelectorAll(
  '.sideNav_navContent-top_line'
);
const barOne = document.querySelector('.nav-hamburger__bars_bar1');
const barTwo = document.querySelector('.nav-hamburger__bars_bar2');
const barThree = document.querySelector('.nav-hamburger__bars_bar3');

hamburger.addEventListener('click', () => {
  skrim.classList.toggle('toggle');
  sideWrap.classList.toggle('toggle');
  sideNav.classList.toggle('toggle');
  sideNavContent.classList.toggle('toggle');

  sideNavContentLine.forEach((sideNavContentL) => {
    sideNavContentL.classList.toggle('toggle');
  });

  barOne.classList.toggle('toggle');
  barTwo.classList.toggle('toggle');
  barThree.classList.toggle('toggle');

  hamburgerBefore.classList.toggle('toggle');
  hamburgerInner.classList.toggle('toggle');

  if (sideNav.classList.contains('toggle')) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto';
  }
});
// Hamburger Nav Open/Close
